module.exports = __webpack_public_path__ + "img/21.2437e5fb.jpg";